import * as Sentry from "@sentry/react";
import { shouldInitSentry } from "./shouldInitSentry";

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (shouldInitSentry(import.meta.env.MODE, dsn)) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION || undefined,
    sendDefaultPii: false,
    tracesSampleRate: 0.1,
    tracePropagationTargets: ["https://app.mivo.digital"],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Transient SW script fetches (offline / flaky network) surface as unhandled
    // rejections from registration.update() / vite-plugin-pwa — not actionable.
    // SignalR rejects an internal handshake promise with "Handshake was canceled"
    // when the socket is aborted mid-connect; the hub managers already handle it.
    ignoreErrors: [
      /Failed to update a ServiceWorker/i,
      /Failed to register a ServiceWorker/i,
      /Handshake was canceled/i,
    ],
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
  });
}
